<div class="order-total">
    <div class="line">
        <span>{{ 'PAY_AT_TABLE.CHEQUE' | translate }}</span>
        <span>{{ billAmount | currencySpace }}</span>
    </div>

    <div class="line">
        <h5>{{ 'PAY_AT_TABLE.REMAINING' | translate }}</h5>
        <h5>{{ totalRemaining | currencySpace }}</h5>
    </div>
</div>

<div class="input-btn-box">
    <div class="box">
        <input #customInput class="pill-input" type="number" [attr.value]="customAmount || ''"
            (input)="onAmountInput($any($event.target).valueAsNumber)"
            (blur)="onAmountBlur(customInput)"
            [max]="totalRemaining" min="1" 
            placeholder="{{ 'PAY_AT_TABLE.CUSTOM_AMOUNT_PLACEHOLDER' | translate }}"
            />
        <button class="btn" mat-raised-button type="button" (click)="submit.emit()">
            {{ 'PAY_AT_TABLE.ADD_CUSTOM_AMOUNT' | translate }}
        </button>
    </div>
</div>